export const styles = {
  icon: {
    marginRight: '15px',
    width: '30px',
    height: '30px',
    '@media (max-width: 360px)': {
      display: 'none',
    },
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '30px',
    '@media (max-width: 440px)': {
      margin: '20px 0 10px 0',
    },
  },
  title: {
    fontFamily: 'Rubik, sans-serif',
    fontWeight: 'normal',
    fontSize: '22px',
    color: '#354052',
    margin: 0,
  },
  section: {
    backgroundColor: 'white',
    marginBottom: '20px',
    border: '1px solid #e6eaee',
    boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.03)',
    borderRadius: '4px',
    paddingBottom: '48px',
    '&:last-child': {
      marginBottom: 0,
    },
    '@media (max-width: 750px)': {
      '&:last-child': {
        marginBottom: '15px',
      },
      paddingBottom: '30px',
    },
  },
  sectionTitleWrapper: {
    borderBottom: '1px solid #c5d0de',
    padding: '15px',
  },
  sectionTitle: {
    fontFamily: 'Segoe UI, sans-serif',
    fontSize: '18px',
    fontWeight: 600,
    margin: 0,
    color: '#323c47',
    '@media (max-width: 750px)': {
      fontSize: '16px',
    },
  },
  sectionList: {
    padding: '0 24px',
  },
  sectionListItem: {
    borderBottom: '1px solid #c5d0de',
    padding: '30px 0',
  },
  sectionListItemWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  sectionListItemLeftPart: {},
  sectionListItemTitle: {
    margin: 0,
    fontFamily: 'Segoe UI, sans-serif',
    fontWeight: 'normal',
    fontSize: '18px',
    color: '#323c47',
  },
  sectionListItemRightPart: {},
  sectionListItemRightPartStacked: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '14px',
  },
  settingsWrapper: {
    display: 'flex',
    padding: '30px 15px 20px',
    gap: '20px',
    '@media (max-width: 750px)': {
      flexDirection: 'column',
    },
  },
  leftPart: {
    flex: 1,
    '@media (max-width: 750px)': {
      marginBottom: '20px',
      flex: 'auto',
    },
  },
  rightPart: {
    flex: 1,
    '@media (max-width: 750px)': {
      flex: 'auto',
    },
  },
  rightPartSection: {
    height: '100%',
  },
};
